import vailcode from "@utils/errcode";
export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    // 获取活动列表
    getActivityList: async () => {
      return new Promise(async (resolve, reject) => {
        const res = await _v.$http.post("/events/list", {});
        vailcode(
          res,
          () => {
            const data = res.data;
            if (!data) {
              resolve();
              return;
            }

            resolve(
              data.map((item) => {
                return {
                  ...item,
                  isStatus: null,
                  currentTime: null,
                };
              })
            );
          },
          () => {
            resolve();
          }
        );
      });
    },
    // 获取参与活动列表
    getPartyActivityList: async (_, params) => {
      return new Promise(async (resolve, reject) => {
        const res = await _v.$http.post("/events/results", params);
        vailcode(
          res,
          () => {
            const data = res.data;
            if (!data) {
              resolve();
              return;
            }
            resolve(data);
          },
          () => {
            reject();
          }
        );
      });
    },
    // 获取参与活动列表
    getHistoryActivityList: async (_, params) => {
      return new Promise(async (resolve, reject) => {
        const res = await _v.$http.post("/events/history/list", params);
        vailcode(
          res,
          () => {
            const data = res.data;
            if (!data) {
              resolve();
              return;
            }
            resolve(data);
          },
          () => {
            reject();
          }
        );
      });
    },
    // 参与活动【投票】
    getActivitySubmit: async (_, params) => {
      return new Promise(async (resolve, reject) => {
        const res = await _v.$http.post("/events/submit", params);
        vailcode(
          res,
          () => {
            const data = res.data;
            if (!data) {
              resolve();
              return;
            }
            resolve(data);
          },
          () => {
            resolve();
          }
        );
      });
    },
    activityClaim: async (_, params) => {
      return new Promise(async (resolve, reject) => {
        const res = await _v.$http.post("/events/claim", params);

        vailcode(
          res,
          () => {
            const data = res.data;
            if (!data) {
              resolve();
              return;
            }
            resolve(data);
          },
          () => {
            resolve();
          }
        );
      });
    },
  },
};
